import {
  ADD_TEMPLATE,
  DELETE_TEMPLATE,
  SET_DELETE_TEMPLATE,
  SET_EDIT_TEMPLATE,
  SET_ERROR,
  SET_LOADING,
  SET_TAB,
  SET_TEMPLATES,
  UPDATE_TEMPLATE,
} from "context/types"

export const initialState = {
  tabSelected: 0,
  templates: [],
  loading: false,
  error: null,
  editTemplate: {
    open: false,
    template: null,
  },
  deleteTemplate: {
    open: false,
    template: null,
  },
}

const templatesManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TAB:
      return {
        ...state,
        tabSelected: action.payload,
      }

    case SET_TEMPLATES:
      return {
        ...state,
        templates: action.payload,
        error: null,
      }

    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      }

    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_TEMPLATE:
      return {
        ...state,
        templates: [...state.templates, action.payload],
      }

    case UPDATE_TEMPLATE:
      return {
        ...state,
        templates: state.templates.map(template =>
          template.id === action.payload.id
            ? { ...template, ...action.payload }
            : template,
        ),
      }

    case DELETE_TEMPLATE:
      return {
        ...state,
        templates: action.payload.templates,
      }

    case SET_EDIT_TEMPLATE:
      return {
        ...state,
        editTemplate: action.payload,
      }

    case SET_DELETE_TEMPLATE:
      return {
        ...state,
        deleteTemplate: action.payload,
      }

    default:
      return state
  }
}

export default templatesManagerReducer
